// test1495
(1495 && 0);
